const getBusinessAddress = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Address'] && business['Company Address'].ID) {
    if (business['Company Address'].Suite) {
      return `${business['Company Address'].Street} SUITE. ${business['Company Address'].Suite}, ${business['Company Address'].City}, ${business['Company Address'].State} ${business['Company Address']['Zip Code']}`.toUpperCase();
    }
    return `${business['Company Address'].Street}, ${business['Company Address'].City}, ${business['Company Address'].State} ${business['Company Address']['Zip Code']}`.toUpperCase();
  }
  return null;
};

export default getBusinessAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessAddress.js